import React from 'react';
import { Box, Paper } from '@mui/material';
import RequestFormTitle from './RequestFormTitle';
import RequestFormToggle from './RequestFormToggle';
import { IRequestType } from '../../../constants/interfaces';
import RequestForm from '../../Request/RequestForm';
import { useLayout } from '../../../contexts/LayoutContext';
import BackButton from '../../../components/BackButton';
import {
  requestFormPageShellSx,
  requestFormHeaderRowSx,
  requestFormPaperSx,
} from '../../../styles/requestFormShell';

interface RequestFormViewProps {
  requestType: IRequestType;
}

const RequestFormView = ({ requestType }: RequestFormViewProps) => {
  const { useGrid, handleToggle } = useLayout();
  const handleBackToHome = () => {
    window.history.length > 1
      ? window.history.back()
      : window.location.assign('/');
  };
  return (
    <Box sx={requestFormPageShellSx}>
      {/* Back button, title, and toggle in the same row */}
      <Box sx={requestFormHeaderRowSx}>
        <BackButton onClick={handleBackToHome} />
        <RequestFormTitle title={`Servicer ${requestType.name} Request`} />
        <RequestFormToggle useGrid={useGrid} onToggle={handleToggle} />
      </Box>
      <Paper elevation={0} sx={requestFormPaperSx}>
        <RequestForm requestType={requestType} useGrid={useGrid} />
      </Paper>
    </Box>
  );
};

export default RequestFormView;
